import { AdBanner } from '@techminds/ad-banner';
import classNames from 'classnames/bind';
import { useEffect, useMemo, useState } from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const ads = [
  {
    adUnitId: 'tm_travel_flight_hotel_recommend_0',
    uct: 'KR',
  },
  {
    adUnitId: 'tm_travel_flight_hotel_recommend_1',
    uct: 'KR',
  },
];

const PromotionBanners = () => {
  const [deviceType, setDeviceType] = useState('mobile');
  const [promotionBannerLoadedList, setPromotionBannerLoadedList] = useState<
    boolean[]
  >(new Array(ads.length).fill(false));

  const isBannerLoaded = promotionBannerLoadedList.some(
    promotionBannerLoaded => promotionBannerLoaded,
  );

  const hostMeta = useMemo(
    () => ({
      env: deviceType,
    }),
    [deviceType],
  );

  useEffect(() => {
    setDeviceType(window.innerWidth <= 768 ? 'mobile' : 'pc');
  }, []);

  return (
    <div
      className={cx('PromotionBanners', isBannerLoaded && 'loaded')}
      key="promotionBanner"
    >
      {ads.map((adSlotInfo, index) => {
        const handleAdLoaded = () => {
          setPromotionBannerLoadedList(prev => {
            const copiedPrevLoadedList = [...prev];
            copiedPrevLoadedList[index] = true;
            return copiedPrevLoadedList;
          });
        };
        return (
          <div
            className={cx(
              'banners',
              promotionBannerLoadedList[index] && 'loaded',
            )}
            key={adSlotInfo.adUnitId + index}
          >
            <AdBanner
              adSlotInfo={adSlotInfo}
              hostMeta={hostMeta}
              onAdLoaded={handleAdLoaded}
            />
          </div>
        );
      })}
    </div>
  );
};

export default PromotionBanners;
